"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableToolbarButtonAction = void 0;
const react_1 = __importStar(require("react"));
const event_callback_hook_1 = require("../../utils/event-callback-hook");
const prompt_register_hook_1 = require("../prompt/prompt-register-hook");
const prompt_context_1 = require("../prompt/prompt-context");
const table_toolbar_button_1 = require("./table-toolbar-button");
const lodash_1 = require("lodash");
const react_intl_1 = require("react-intl");
const snackbar_context_1 = require("../snackbar/snackbar-context");
const snackbar_types_1 = require("../snackbar/snackbar-types");
const table_context_1 = require("./table-context");
function TableToolbarButtonAction({ promptKey, apiCall, buttonLabel, buttonTooltip, dialogText, dialogTitle, dialogWidth, FormFields, formValidationSchema, formInitialValues, successMessage, errorMessage, onSuccess: providedOnSuccess, onError: providedOnError, onResult: providedOnResult, onShouldShow = lodash_1.stubTrue, ButtonComponent = table_toolbar_button_1.TableToolbarButton, buttonProps = {}, ...restProps }) {
    const intl = react_intl_1.useIntl();
    const { showSnackbar } = react_1.useContext(snackbar_context_1.SnackbarContext);
    const { testPrompt } = react_1.useContext(prompt_context_1.PromptContext);
    const { source } = react_1.useContext(table_context_1.TableContext);
    const { selected } = react_1.useContext(table_context_1.TableSelectedContext);
    const fetch = react_1.useRef(null);
    prompt_register_hook_1.usePrompts([
        {
            key: promptKey,
            dialogTitle,
            dialogText,
            dialogWidth,
            FormFields,
            formValidationSchema,
            formInitialValues,
        },
    ], [
        promptKey,
        dialogTitle,
        dialogText,
        dialogWidth,
        FormFields,
        formValidationSchema,
        formInitialValues,
    ]);
    const defaultOnSuccess = event_callback_hook_1.useEventCallback(async () => {
        // do nothing
    });
    const defaultOnResult = event_callback_hook_1.useEventCallback(() => {
        const message = successMessage !== null && successMessage !== void 0 ? successMessage : intl.formatMessage({
            id: 'EAS_DETAIL_ACTION_MSG_SUCCESS',
            defaultMessage: 'Akce byla úspěšně vykonána.',
        });
        showSnackbar(message, snackbar_types_1.SnackbarVariant.SUCCESS);
    });
    const onSuccess = providedOnSuccess !== null && providedOnSuccess !== void 0 ? providedOnSuccess : defaultOnSuccess;
    const onError = providedOnError !== null && providedOnError !== void 0 ? providedOnError : defaultOnError;
    const wrappedApiCall = event_callback_hook_1.useEventCallback(async (formData) => {
        try {
            source.setLoading(true);
            if (fetch.current !== null) {
                fetch.current.abort();
            }
            fetch.current = apiCall(source.getParams(), selected, formData);
            const response = await fetch.current.raw();
            if (providedOnResult !== undefined) {
                const json = await response.json();
                await providedOnResult(json);
            }
            else {
                defaultOnResult();
            }
            source.setLoading(false);
            await onSuccess();
        }
        catch (err) {
            source.setLoading(false);
            if (err.name !== 'AbortError') {
                const message = errorMessage !== undefined
                    ? errorMessage.replace('{detail}', err.message)
                    : intl.formatMessage({
                        id: 'EAS_DETAIL_ACTION_FINISH_ERROR',
                        defaultMessage: 'Chyba volání akce: {detail}',
                    }, { detail: err.message });
                showSnackbar(message, snackbar_types_1.SnackbarVariant.ERROR);
                await onError(err);
            }
            return undefined;
        }
    });
    const handleConfirm = event_callback_hook_1.useEventCallback(async () => {
        testPrompt({
            key: promptKey,
            callback: wrappedApiCall,
        });
    });
    return (react_1.default.createElement(react_1.default.Fragment, null, onShouldShow() && (react_1.default.createElement(ButtonComponent, Object.assign({}, buttonProps, { label: buttonLabel, tooltip: buttonTooltip, onClick: handleConfirm }, restProps)))));
}
exports.TableToolbarButtonAction = TableToolbarButtonAction;
async function defaultOnError(err) {
    throw err;
}
//# sourceMappingURL=table-toolbar-button-action.js.map